import {
    clamp, debounce
} from 'lodash';
import { formatCurrency } from '../helpers';
import { updateQuoteBoost } from '../local-site/quoteboost';

window.componentAmountPlusMinus = function (min, max, value, step) {
    return {
        slider: null,
        min: min,
        max: max,
        value: value,
        step: step,
        init() {
            //if loan amount has been saved to local storage then set the slider value to that
                var storageValue = localStorage.getItem("loanAmount");
                if (storageValue) {
                    this.value = storageValue;
                };
            var valueBubble = '<output class="rangeslider__handle-tooltip" x-text="valueFormatted()"/><div class="pointer"></div>';
            // var valueSqueek = '<div class="flex justify between"><p>£1,500</p><p>£10,000</p></div>';
            this.slider = $('input[type="range"]').rangeslider({
                value: this.value,
                polyfill: false,
                onInit: function () {
                    this.$range.find('.rangeslider__handle').append($(valueBubble));
                },
                onSlide: (pos, value) => {
                    this.sliderOnSlide(value);
                }
            });
            //this updates any values that are locked or N/A when you first land on the prepop page
            if ($('body').is('.pl-prepop')) {
                this.updateValue(value);
            }

            this.$nextTick(() => {
                $('input[type="range"]').rangeslider('update', true);
                updateQuoteBoost();
            });
        },
        sliderOnSlide: debounce(function(value){
            if (value !== this.value) {
                this.updateValue(value);
            }
            var laHeaders = document.getElementsByClassName('header-la');
            if (laHeaders.length > 0) {
                document.querySelector('.header-la').textContent = this.value;
            }
        }, 10), 
        valueFormatted() {
            return '£' + formatCurrency(this.value);
        },
        updateValue(newVal) {
            let cleanVal = newVal.toString().replace(/[\D]/, '');
            if (cleanVal == '' || cleanVal == null) {
                cleanVal = this.min;
            }
            this.value = clamp(Math.floor(  
                parseInt(
                    cleanVal.toString().replace(/[\D]/, ''),
                    10
                    ) / this.step) * this.step,
                this.min,
                this.max);
            if (this.slider.val() != this.value) {
                this.slider.val(this.value).change();  
            }
            if (this.slider.val() == this.min || this.slider.val() == this.max) {
                this.clearInterval();
            }
            let form = this.slider.closest('form');
            formPageTermBlockout(form, this.value);

            // Pass the loan amount value to local storage
            if ($('body').is('.pl-form') || $('body').is('.loans-home')|| $('section').is('.swifto-loans') ) {
                localStorage.setItem("loanAmount", this.slider.val());
            }
            updateQuoteBoost();
        },
        updateFromTextbox(event) {
            this.updateValue(event.target.value);
        },
        increment() {
            this.updateValue(parseInt(this.value, 10) + this.step);
        },
        decrement() {
            this.updateValue(parseInt(this.value, 10) - this.step);
        },
        mouseDownInterval(increment) {
            increment ? this.increment() : this.decrement();
            this.intervalID = setInterval(() => {
                increment ? this.increment() : this.decrement();
            }, 100);
        },

        clearInterval() {
            clearInterval(this.intervalID);
        },
        
    }
    
};

var formPageTermBlockout = function(form, value) {
    value = parseInt(value);
    var term = form.find('[name=term]');
    var termGroup = form.find('.term-form-group')
    var termVal = parseInt(term.val());
    var changeTermGroup = function(term){
        termGroup.find('[data-value=' + term + ']').click();
    };
    if(value <= 900){
        termGroup.find('[data-value=3],[data-value=6]').removeClass('hidden');
        termGroup.find('[data-value=48],[data-value=60]').addClass('hidden');
        termGroup.find('[data-value=3],[data-value=6]').removeClass('locked').each(function(i,o){
            $(o).find('.pseudo-select-text').text($(o).data('value') + ' Months');
        });
        termGroup.find('[data-value=18],[data-value=24],[data-value=36]').addClass('locked').removeClass('pseudo-selected').each(function(i,o){
            $(o).find('.pseudo-select-text').text('N/A');
        });
        if(termVal >= 18){
            changeTermGroup(12);
        }
    } else if (value === 1000){
            termGroup.find('[data-value=3],[data-value=6]').removeClass('hidden');
            termGroup.find('[data-value=48],[data-value=60]').addClass('hidden');
            termGroup.find('[data-value=3],[data-value=6],[data-value=12],[data-value=18],[data-value=24],[data-value=36]').removeClass('locked').each(function(i,o){
                $(o).find('.pseudo-select-text').text($(o).data('value') + ' Months');
            });
    } else if (value >= 1100 && value <= 2000){
        termGroup.find('[data-value=3],[data-value=6]').removeClass('hidden');
        termGroup.find('[data-value=48],[data-value=60]').addClass('hidden');
        termGroup.find('[data-value=6],[data-value=12],[data-value=18],[data-value=24],[data-value=36]').removeClass('locked').each(function(i,o){
            $(o).find('.pseudo-select-text').text($(o).data('value') + ' Months');
        });
        termGroup.find('[data-value=3]').addClass('locked').removeClass('pseudo-selected').each(function(i,o){
            $(o).find('.pseudo-select-text').text('N/A');
        });
        if(termVal <= 3){
            changeTermGroup(12);
        }
    } else if (value >= 2100 && value <= 2500) {
        termGroup.find('[data-value=3],[data-value=6]').removeClass('hidden');
        termGroup.find('[data-value=48],[data-value=60]').addClass('hidden');
        termGroup.find('[data-value=12],[data-value=18],[data-value=24],[data-value=36]').removeClass('locked').each(function(i,o){
            $(o).find('.pseudo-select-text').text($(o).data('value') + ' Months');
        });
        termGroup.find('[data-value=3],[data-value=6]').addClass('locked').removeClass('pseudo-selected').each(function(i,o){
            $(o).find('.pseudo-select-text').text('N/A');
        });
        if(termVal <= 6){
            changeTermGroup(12);
        } else if (termVal >=48){
            changeTermGroup(36);
        }
    } else if (value >= 2600 && value < 5000) {
        termGroup.find('[data-value=3],[data-value=6]').addClass('hidden');
        termGroup.find('[data-value=48],[data-value=60]').removeClass('hidden');
        termGroup.find('[data-value=12],[data-value=18],[data-value=24],[data-value=36]').removeClass('locked').each(function(i,o){
            $(o).find('.pseudo-select-text').text($(o).data('value') + ' Months');
        });
        termGroup.find('[data-value=3],[data-value=6]').addClass('locked').removeClass('pseudo-selected').each(function(i,o){
            $(o).find('.pseudo-select-text').text('N/A');
        });
        if(termVal <= 6){
            changeTermGroup(12);
        }     
    }
    setTimeout(() => {
        updateQuoteBoost();
    }, 25);
};